export default {
    en: {
        s1: 'PROGRESS',
        s11: 'Application Progress for Oversea Works in Hong Kong and Philippines',
        main: 'Home',
        search: 'Search',
        about: 'About',
        services: 'Services',
        price: 'Price',
        form: 'Form',
        renew: 'Online Service',
        pay: 'Pay for helper',
        relax: 'Relax',
        ihelp: 'Hiring a Helper has never been easier',
        ibo: 'Best offer',
        ioro: 'Only renew online',
        company: 'GOLDEN WIN EMPLOYENT AGENCY LTD',
        id1: 'For busy Hong Kong citizens who cannot afford down time to cook, do house chores, baby sit and provide',
        id2: 'elderly care. GOLDEN WIN EMPLOYENT AGENCY LTD. is commited to matching hardworking domestic',
        id3: 'helpers with suitable employers through the careful assessment of needs and personalities.',
        ih1: 'Easy Search',
        ic1: 'Need to hire a helper now? Check out our list of helpers standing by for interview. GoldenWin has new applicants every day from over ten branches in the Philippines.',
        more: 'More',
        ih2: 'Easy Payment',
        ic2: 'Make payment anywhere! Just make the payment at home after confirming with us the helper you would like to employ, and we will be in-touch to guide you every step of the way.',
        ih3: 'Easy Renew',
        ic3: 'Get the best rates in town. When renewing provide us with the relevant documents and we will take care of the rests.',
        iss: 'Seach for a Helper Now',
        iss1: 'Get connected to Helpers from Philippines!',
        iss2: 'Take your time to find Helpers that suit your needs by viewing their profile and add them to your favorites!',
        explore: 'Explore',
        touch: 'GET IN TOUCH',
        touch1: 'Give us a call or email any time and we will get back to you within 24 hours during working days.',
        phone: 'Your email',
        name: 'Your name',
        message: 'Your message',
        send: 'SEND',
        director: 'Director',
        consultant: 'Consultant',
		assistance: 'Assistance',
        secretary: 'Admin secretary',
        des: 'Golden Win is committed and continuously strives to become your preference source for employment and human resource service, hepling you in every step of the way.',
        reseve: 'Golden Win Employment Agency All rights reserved.',
        company1: 'TUEN MUN',
        maino: 'VIP RECEPTION ROOM',
        sideo: '',
        addr1: 'UNIT 21, G/F, TUEN MUN CENTRAL SQUARE',
        addr11: 'NO. 22 HOI WING ROAD, TUEN MUN, N.T.',
        company2: 'Tai Po',
        addr2: 'G/F, SHOP 1A, 35 PO HEUNG STREET',
        addr21: 'PO HONG BUILDING, TAIPO, HONGKONG',
        company3: 'Tin Shui Wai',
        addr3: 'SHOP 3063, 3/F, ONE SKY MALL',
        addr31: '8 TIN SAU ROAD TIN SHUI WAI',
        company4: 'Shau Kei Wan',
        addr4: 'SHUOP 1015, 1/F, SMILING SHAUKEIWAN PLAZA',
        addr41: 'NO.17 NAM HONG STREET, SHAU KEI WAN, HONG',
        company5: 'Kwun Tong',
        addr5: 'FLAT A7,9/F,BLK3,CAMELPAINT BUILDING',
        addr51: '60 HOI YUEN ROAD, KWUN TONG',
        company6: 'Tsim Sha Tsui',
        addr6: 'RM39,1/F,BEVERLEY COMMERCIAL CENTER',
        addr61: '87-105 CHATHAM RD SOUTH TSIM SHA TSUI, KOWLOON',
        company7: 'Cheung Sha Wan',
        addr7: 'UNIT C,3/F,LONG TO BUILDING, 654-656',
        addr71: 'CASTLE PEAK ROAD,CHEUNG SHA WAN, KOWLOON',
        company8: 'Wan Chai',
        addr8: 'Shop 22, G/F, New Century Plaza',
        addr81: '151-163, Wan Chai, Hong Kong',
        search1: `Today's New Applicant in the Philippines (Monday - saturday  at 10:00 am)`,
        code: 'Code',
        name1: 'Name',
        age: 'Age',
        birth: 'Birthday',
        zodiac: 'Zodiac',
        marriage: 'Marital Status',
        kids: 'Kids',
        st1: 'Love',
        st2: 'Love',
        st3: 'Love',
        religion: 'Religion',
        favorite: 'My favorite',
        favorite11: 'Favorite',
        status: 'Status',
        about1: 'Welcome to Golden Win Employment Agency Ltd., founded by Jenny, where we strive to collaborate with you towards a common goal.',
        about2: "We are committed to serving families in Hong Kong, particularly busy parents with young children and their domestic helpers. We understand that nurturing children during the early stages of development is extremely hard work, demanding much time and energy. That's why we aim to empower parents and their helpers with practical resources and emotional support to achieve mutual benefit within the household.",
        about3: `Our company's unique value lies in providing Domestic Helpers who are first-time overseas in Hong Kong. Our mission is to give employers and helpers new to Hong Kong a positive work experience as they integrate into a new way of life in Hong Kong. We take pride in our strategy to bridge relational gaps between helpers and their employers. We provide encouragement, emotional and collaborative support to uphold a nurturing environment for your newborns, children, and family, since 2006.`,
		about7: `We believe that rapid switches in employee and employer relationships should not be the norm without careful consideration on both sides, as it is financially, emotionally, and time demanding. Instead, we aim to work alongside Hong Kong employers and domestic helpers to break down communication and performance barriers so that mutual benefit can be achieved. We value the opportunity to work side-by-side with our beloved Hong Kong families, supporting you at every stage of your children's growth within the services we provide.`,
		about8: `We understand that the value of extra time, hands, and peace of mind is of utmost importance. We hope that we can be your first choice to provide this service.`,
		about9: `Sincerely, Jenny, 
CEO of GoldenWin Employment Agency LTD.`,
        loca: 'OUR LOCATIONS',
        about4: 'We are dedicated to serving our customers and the community with the highest levels of service, knowledge, passion, professionalism, honesty and integrity.',
        worktime: 'MON-FRI 11:00 am - 5:30pm',
        worktime1: 'SAT 10:30 am - 2:00pm',
        progress: 'PROGRESS',
        progress1: 'Application Progress for Oversea Works in Hong Kong and Philippines',
        price1: 'PRICE LIST',
        price2: 'From the first day the helper worked the home until seven months, if either party resigns or leaves, the employer can replace another overseas Filipino helper once, free of charge.',
        price3: `When you show have VIP card : After  seven months and within twenty-four months of employment contract, the employer is also entitled replacement helper at a cost of VIP fees HK$6,980.`,
        price4: 'Client  birthday month can share the VIP card once for the family or friend to use the VIP price',
        price5: 'For show the VIP card The terms and conditions: ',
        price6: 'Clients who are currently within the employment contract period.',
        price7: 'You can also bring your own helper for renewal.',
		price8: 'If do not renew the next contract after this contract and you are hire oversea helper.',
		price9: '',
		price10: '',
		price11: '',
		price12: '',
        p1: 'Oversea(Ex-Asian)',
        money: 'HKD',
        p2: 'Hire Helpers whom have worked in other parts of Asia',
        p21: 'Hire Helpers whom have worked in the Middle East',
        p3: 'Notarization Fee(Charge by the Consulate General in HK)',
        p4: 'Working Visa Application Fee',
        p5: 'Air Ticket to HK',
        p6: 'Application Process',
        p7: '2 Year Follow up Support Services Fee Upon Mail Arrival',
        p8: 'Airports Pick Up',
        p9: 'HKID Card Apply',
        p10: 'Medical Check In HK',
        p11: '2 Days Boarding House(Including Food, Daily Needs)',
        p111: 'Add content including Philippines process fees',
        pp2: 'Oversea(Ex-Mideast)',
        pp3: 'First Time in other Country',
        pp4: 'Hire Helpers whom have worked locally in the Philippines.',
        p12: 'Direct-Hire Overseas',
        p13: "For employers who has a target helper in mind that is not under Goldenwin's database",
        p14: 'Renew At Branch',
        p15: 'Renew a contract with us, either with your previous employee or with a new helper with a new helper who has work in HK.',
        p151: 'Renew a contract with us, either with your previous employee or with a new helper with a new helper who has work in HK.',
        p16: 'OWWA Fees',
        p17: 'Renew Online',
        p18: 'Direct Hire Finish Contract ',
		p19: 'Direct Hire Oversea ',
        p181: 'For Employers who have a target Helper in mind that has completed their two years contract in Hong Kong.',
        insu: 'Insurance',
        cname: 'Company Name:',
        cname1: 'Mutual Insurance Consulatants.co',
        ty: 'Two Years',
        df: 'DOWNLOAD FORM',
        wa: 'WhatsApp Us For Any Inquiries',
        form1: 'FORM DOWNLOAD',
        form2: 'Statutory <HK>',
        form3: 'Statutory Holidays <EN>',
        form4: 'Labour Booklet',
        form41: 'Bilingual(EN&CN)',
        form5: 'Application Form',
        form51: 'ID407E   Notification of Termination of an Employment Contract',
        form52: 'ID988A   Visa/Extension of Stay Application Form for Domestic Helpr from Abroad',
        form6: 'Immigration Department',
        form7: 'Labour Department',
        form8: 'Labour Calcuation Form for Domestic Helper',
        form9: 'Helper’s Insurance Brochure',
        download: 'Download',
        detail: 'Detail',
        renew1: 'RENEW CONTRACT',
        renew2: 'Thank you for using our [HR management services]',
        renew3: 'Add New Family Member',
        renew31: 'Add',
        renew4: 'Back to home',
        renew5: '2 Year Maidsafe Insurance',
        renew6: `Interested in getting a discount through Golden Win on your Help's health insurance? If so, please contact your agency.`,
        renew7: 'Service Selection',
        select: 'SELECT',
        step: 'Step',
        step1: 'Upload Information',
        step2: 'Payment',
        step3: 'Send File',
        pf1: 'Name of Helper',
        pf2: 'Salary',
        pf3: 'When would you like your helper start to work?',
        pf3a: 'As soon as possible',
        pf3b: 'After',
        pf4: 'Name of Employer',
        pf41: 'EMPLOYER HKID NO',
        pf5: `Emergency Contact’s Mobile (Philippines)`,
        pf51: `Employer mobile`,
        pf6: 'Branch',
        pf7: 'Where do you want to sign the Documents?',
        pf7a: 'Branch',
        pf7b: 'SF Express',
        pf8: 'Mailing Address',
        pf9: 'No.Of Adults at Home(Excluding Helper)',
        pf10: 'No.Of Elderly',
        pf11: 'Healthy Condition of the Elderly ',
        pf12: 'No.Of Children',
		pf121: 'No.Of Children',
        pf13: 'Age Of Children: Please calculate as this year',
		pf131: 'Age Of Children: Please calculate as this year',
        pf14: 'Expecting Baby',
		zz15: 'No. of Expecting Baby',
        pf15: 'Date of Delivery',
        pf16: 'Type of Housing',
        pf17: 'Size of Flat/House',
        pf171: 'Size of Flat/House',
        pf18: 'No.Of Bedrooms',
        pf19: `Maid's Sleeping Arrangement`,
        pf20: 'Main Duties:',
        pf21: 'Caring for Newborn',
        pf22: 'Caring of toddler(1-3)',
        pf23: 'Cooking',
        pf24: 'Cleaning',
        pf25: 'Elderly Care',
        pf26: 'Ironing',
        pf27: 'Laundry',
        pf28: 'Groceries',
        pf29: 'Gardening',
        pf30: 'Car Wash',
        pf31: 'Pet care',
        pf32: 'Others',
        pf33: 'Household chore',
        pf34: 'Caring of children(4-6)',
        pf35: 'Remarks(If applicable)',
        pf36: 'Are you replacing a helper?',
        pf37: 'Are there more than one helper in the house?',
		pf38: `Maid's Sleeping Arrangement`,
        pre: 'Previous',
        next: 'Next',
        colon: ':',
        aservice: 'Additonal Services',
        none: 'None',
        a2y: '2 Year MaidSafe Insurance',
        insdetail: 'Insurance Detail',
        renewcost: 'Contract Renew Cost',
        total: 'Total',
        payamount: 'Payment amount',
        pay1: 'Pay',
        favorite1: 'MY FAVORITE',
        available: 'Available',
        notavailable: 'Hired',
        signin: 'Sign in',
        areaCode: 'Area code',
        phone1: 'Phone number',
        certify: 'PIN',
        getCertify: 'Whatsapp  OTP',
        password: 'Password',
        password1: 'Create New Password',
        password2: 'Re-enter Password',
        password3: 'Your password has been successfully updated.',
        password4: 'Please login!',
        noaccount: `Don't have an account?`,
        signup: 'Sign up',
        adminsignin: 'Admin Sign In',
        domesticsignin: 'Domestic Helper Sign In',
        domesticsignup: 'Domestic Helper Sign Up',
        su1: 'Create new account',
        su2: `Use your work email to create new account. It's free!`,
        fn: 'First Name',
        ln: 'Last Name',
        su3: 'I have read the ',
        tac: 'Terms and Conditions',
        tac1: 'Private Policy and Person Data Declaration',
        su4: 'SIGN UP NOW',
        su5: 'Have an account?',
        filter: 'Filter',
        sc: 'Search by Code',
        age1: 'Under 25',
        age2: 'Above 40',
        nomatter: 'No Preference',
        m0: 'Live In Partner',
        m1: 'Single',
        m2: 'Married',
        m3: 'Separated',
        m4: 'Widow',
        m5: 'Solo',
        son1: 'More than 1',
        zo1: 'Rat',
        zo2: 'Ox',
        zo3: 'Tiger',
        zo4: 'Rabbit',
        zo5: 'Dragon',
        zo6: 'Snake',
        zo7: 'Horse',
        zo8: 'Sheep',
        zo9: 'Monkey',
        zo10: 'Rooster',
        zo11: 'Dog',
        zo12: 'Pig',
        pff1: 'PORTFOLIO',
        share: 'Share',
        print: 'Print',
        export: 'PDF Export',
        pff2: 'Oversea Experiences',
        pff3: 'Work Experiences',
        pff4: 'Language',
        pff41: 'Youtube Interview',
        pff5: 'Remark',
        pff6: 'Serious Sick Before',
        pff7: 'Mental Issue',
        pff8: 'High Blood',
        pff9: 'Lung Disease',
        pff10: 'Smoking',
        pff101: 'Skin Allergy',
        pff11: 'Tattoo',
        pff12: 'Family Background',
        pff13: 'Father Name',
        pff14: 'Mother Name',
        pff15: 'No. of Borther & Sister',
        pff16: 'Home Address',
        pff17: 'City/Town',
        pff18: 'Province',
        pff181: 'Postal Code',
        pff19: 'Height',
        pff20: 'Weight',
        account: 'ACCOUNT',
        account1: 'Login',
        contract: 'Contract',
        contractp: 'Contract Period',
        un: 'User Name',
        edit: 'Edit',
        save: 'Save',
        hi: 'Helper Information',
        r1: `Name of Emergency Contact`,
        r2: 'Relationship with Helper',
        r3: 'Helper Name',
        r4: 'Helper Email Address',
        r5: 'Civil Status',
        r51: 'To All Helpers:',
        r52: 'Please WhatsApp Jeany Rose(+639502100238) about how to send other important documents to complete the application.',
        r6: 'Employer Information',
        flat: 'Flat',
        house: 'House',
        r7: 'Age Of Children( 5-18 years old) Please calculate as this year',
        r8: 'Age Of Children( 0-5 years old) Please calculate as this year',
        r9: 'No. Of Expected Baby',
        r10: `Helper's Accommodation Details`,
        r11: `Helper's Room`,
        r12: 'Yes. Estimated size of the servant room',
        r13: 'Sq',
        r14: 'meter',
        r15: 'ft',
        r16: 'No. Sleeping arrangement for Helper:',
        r17: 'Share a room with',
        r18: 'children',
        r19: '',
        r191: 'Seperate partitioned area of ',
        r20: 'Others. Please describe',
        r21: `Family member's detail for Immigration Department need`,
        r22: 'English Full Name',
        r23: 'Relationship',
        r24: 'Year of Birth',
        r25: 'HKID No.',
        r26: 'Add New Family Member',
        r27: 'Permitted to Remain Until(Date in white visa slip)',
        r28: 'Release Date From Existing Employer(Only for Switching Employer)',
        r29: 'REMARKS',
        r30: 'Information of Helper Being Replaced (if applicable)',
        r31: 'Helper’s Full Name',
        r32: 'HKID NO.',
        r33: 'Release Date From Existing Employer',
        r34: 'Information of Other Helpers in the House (if applicable)',
        r35: 'Permitted to Remain Until (see white visa slip)',
        r36: 'Release Date From Existing Employer',
        r37: 'Name of Employer',
        r38: 'Room Arrangement',
        a1: '2 Years Follow up Support Services Contact Shop For Assistance',
        a2: 'Medical Check in HK',
        pr1: 'WhatsApp Us To Arrange An Interview',
        pr2: 'Mon - Fri',
        pr3: 'Sat',
        pr4: 'SAMPLE MESSAGE:',
        pr5: 'I am Mr.lee, living in (mongkok). I would like to interview helpers (T1-DVO0001 , T1-BXN0002 , and T1-BCD0003) on (20/02 2:00 pm). My WhatsApp/ Mobile is (5611 1111)',
        cancelpay: 'Cancel Payment!',
        m: 'mobile',
        success: 'Success',
        paySuccess: 'Pay Success!',
        cancel: 'Cancel',
        l1: 'Please send us the following documents by Email or Whatsapp',
        l2: `Employer's HKID`,
        l3: 'Proof of Income',
        l31: 'Tax note',
        l32: 'Payroll of the past three months',
        l33: 'Bank statement past three months showing salary transaction',
        l34: 'Fix deposit of HKD $360000, OR',
        l35: 'Pass six months saving balance $360000',
        l4: 'Address',
        l41: 'Water bill',
        l42: 'Electricity bill',
        l43: 'Towngas bill OR',
        l44: 'Internet bill',
        l5: 'Relationship Certificate',
        l51: `If your proof of address is not under the employer's name. Please provide the proof of your relationship to the owner address.`,
        l52: 'Relationship certificate',
        l53: 'Marriage certificate, OR',
        l54: 'Birth certificate',
        l6: 'HKID Card of Relative',
        l61: 'For Helper Replacement',
        l611: 'Existing Helper’s Copy of HKID or Passport',
        l612: 'Existing Helper’s Release date (around)',
        l62: 'For Additional Helpers Under The Same House',
        l621: 'Existing Helper’s Copy of  HKID or Passport',
        l622: 'Existing Helper’s Visa Expiry Date',
        l623: 'Existing Helper’s Employer Name',
        l624: 'Existing Helper’s Current Sleeping Arrangements',
        tr1: 'Please send us a clear picture of the following documents to our contact.',
        tr2: 'All personal documents will be kept confidential and will only be used for employment purposes.',
        tr3: 'Employer & Helper HKID',
        tr4: 'Helper and Employer Contract',
        tr5: 'Page 1 - Page 4',
        tr6: '(Please send each page as a seperate picture)',
        tr7: `Helper's Passport`,
        tr8: `Helper's Visa`,
        skip: 'Skip login for now',
        f1: 'Privacy policy',
        f2: 'Terms and conditions',
        resume: 'RESUME',
        employer_mobile: `Employer's Mobile`,
        employer_name: `Employer's Name`,
        helper_mobile: `Helper's HK Mobile`,
        aperson: 'Login',
        alogout: 'Logout',
        afavorite: 'My Favorites',
        constellation: 'Constellation',
        back: 'Back',
        afterpay1: 'Would you like to book your helper and save your information?',
        afterpay2: 'If yes, please click “Pay/Submit”, otherwise click “Next”',
        paySuccess1: 'Your payment is successful! Please check your email for the receipt.',
        paySuccess2: 'Next Step, please click on the whatsapp icon in the next page and leave a message.',
        paySuccess3: 'Our staff will get back to you within working hours. ',
        signinadd1: 'Login as',
        signinadd2: 'CUSTOMER',
        signinadd3: 'HELPER REGISTRATION',
        signinadd4: 'ADMIN',
        signinadd5: 'Back to Login Option',
        signinadd6: 'Forget Password',
        signinadd7: 'CHANGE',
        signinadd8: 'Back to Login',
        filterMessage: 'Please select two primary needs for your family:',
        fneed: 'Primary Need',
        sneed: 'Secondary Need',
        need1: 'New Born',
        need2: 'Baby Sitting (Ages 1-3)',
        need3: 'Child Care (Ages 4-12)',
        need4: 'Elderly Care',
        need5: 'Cooking',
        need5: 'Grocery',
        zoall: 'Select All Zodiac',
        age1: 'Below Age 29',
        age2: 'Above Age 30',
        reset: 'Reset',
        whatsappmsg: 'Click to Contact Secretary Ms.Tsang',
        sm1: 'Worker Code : ',
        sm2: '1) T1-DV0-00000111',
        sm3: '2) T1-BCD-00000111',
        sm4: '3) T1-ILO-00000111',
        sm5: 'Interview Preference: 2:00-3:00 Sat',
        sm6: 'Your Mobile :  1234 5678',
        sm7: 'From this we can help you arrange an interview with your select Helpers from the Philippines. This button is linked to the WhatsApp number 6036 1888. Please only use it for booking interviews.',
        w1: 'Click here contact our secretary',
        ol1: 'Order id',
        ol2: 'Order type',
        ol3: 'Price',
        ol4: 'Created date',
        ol5: 'Pay date',
        op: 'Operation',
        pay: 'Pay',
        paied: 'Paid',
		b1: 'Save',
		philippines_worker_mobile: 'Helper Mobile',
		process1: `Date`,
		process2: `Helper Code`,
		process3: `Helper Name`,
		process4: `Work Type`,
		process5: `Action`,
		process6: `Process Detail`,
		cancel: `Cancel`,
		confirm: `Confirm`,
		proh1: `Helper Detail`,
		proh2: `Helper Name`,
		proh3: `Helper Type`,
		proh4: `Helper Visa Start`,
		proh5: `Helper Visa Expiry Date`,
		proh6: `Helper Go Down Date`,
		proh7: `Flight Arrive Date`,
		proh8: `Contract Start Date`,
		proh9: `Contract Renewal Date`,
		proz1: `Estimate Arrival Date`,
		proz2: `Days Left`,
		proz3: `Helper Code`,
		proe1: `Employer Name`,
		proe2: `Employer Mobile`,
		proe3: `Mailing Address`,
		proe4: `Employer Detail`,
		paymentN1:`Please select for helper’s catergory `,
		paymentN2:`The system had displays the recent helper information you have hired our service :`,
		paymentN3:`Name of Helper`,
		paymentN4:`Paid Date`,
		paymentN5:`Contract Starting Date`,
		pSelectT: `Your category`,
		pSelectN0: `Please select your type`,
		pSelectN1:`1.Additional helper`,
		pSelectN2:`2.New Client`,
		pSelectN3:`3.Replacement:Helper no yet come HK`,
		pSelectN4:`4.Replacement:Over 14 Months`,
		pSelectN5:`5.Replacement:Within 7 months Confirm new helper from the day of start work`,
		pSelectN6:`6.Replacement:From 8 months till 14 months before confirm new helper`,
		pSelectPay: `Please select method to pay`,
		paypalT1: `Please Select Paypal for Credit Card Payment`,
		paypalT2: `ATM/Bank Transfer`,
		paypalT3: `FPS Transfer`,
		amtH:`ATM/Bank Transfer`,
		amtT:`Please transfer payment into the following account`,
		amt1:`Bank Name：`,
		amt2:`Bank of China (Hong Kong) Limited`,
		amt3:`Account Number：`,
		amt4:`012-831-1-056734-8`,
		amt5:`Account Name：`,
		amt6:`GOLDEN WIN EMPLOYMENT AGENCY LIMITED高菲僱傭有限公司`,
		amtf1:`Please Upload the receipts after you made the payment.`,
		amtf2:`We will contact you once your payment is confirmed.`,
		fpsH:`FPS Transfer`,
		fpsT:`Please transfer payment into the following account`,
		fps1:`Phone Mobile：`,
		fps2:`51604299`,
		fps3:`Please select bank：`,
		fps4:`Bank of China (Hong Kong) Limited (012) `,
		fps5:`Account Name：`,
		fps6:`GOLDEN WIN EMPLOYMENT AGENCY LIMITED高菲僱傭有限公司`,
		pfile:`Broswer`,
		confirmOrder:`Submit`,
		pname: `Process`,
		interview: `Add Interview`,
		interview1: `Make Appointment`,
		interviewTitle: `INTERVIEW LIST`,
		interviewH: `INTERVIEW HISTORY`,
        interview12:`Total Select`,
        interview13:`Make Appointment`,
		interview14:`Appointment`,
		interview15:`Name`,
		interview16:`Gender`,
		interview17:`Mobile`,
		interview18:`Email`,
		interview19:`Date`,
		interSt1:`Please fill in English`,
		interSt2:`Please select your gender`,
		interSt3:`This Mobile must be the same when you pay`,
		interH1:`Code`,
		interH2:`Name`,
		interH3:`Mobile`,
		interH4:`Interview Date`,
		interH5:`Interview Status`,
		interH6:`Interview Result`,
		interH7:`Done`,
		interH8:`At Interview`,
		remove:`Remove`,
		email:`Email Address`,
		interH9:`Reschedule`,
		interviewSubmitContent1:`Dears Client`,
		interviewSubmitContent2:`We received your request inteview appointment.`,
		interviewSubmitContent3:`Shortly you will be receiving our email notifications confirm your appointment in your email.`,
		interviewSubmitContent4:`You will receive our notification by starting line up on 8:00 am and we will inform your interest helper for her status.`,
		selectAll:`All`,
		confirmInterview: `Confirm`,
		paymentRequestT: `Warning`,
		kindlyReminder: `Kindly Reminder`,
		close: `Close`,
		reminderp1:`Helper is add to your Interview List Successfully,`,
		reminderp2:`Please check your [Interview List] to schedule an appointment.`,
		newPaymentRp1:`The current page information is all required`,
    },
    zh: {
        s1: '批核流程',
        s11: '香港和菲律賓的海外手續流程',
        main: '主頁',
        search: '搜尋女傭',
        about: '關於',
        services: '服務',
        price: '價格',
        form: '表格',
        renew: '網上申請',
        pay: '付款',
        relax: '輕鬆',
        ihelp: '揾女傭姐姐在家中幫下手',
        ibo: '最平價格',
        ioro: '只在網上預約！',
        company: '高菲僱傭有限公司',
        id1: '現今香港人在繁忙的生活節奏中好難有時間煮食，做家務，照顧BB以及照顧老人。',
        id2: '高菲僱傭致力配合現今客戶合力輕鬆地和海外女傭安排見面 ，',
        id3: '透過高菲傭僱傭平台選取心儀的海外女傭。',
        ih1: '最簡單的搜尋！',
        ic1: '緊貼最新海外女傭上架，搜索喜愛心水女傭！菲律賓當地女傭公司，透過高菲平台，每天在公司有新女傭即時用 WhatsApp 視頻見面！',
        more: '更多',
        ih2: '最快捷的付款方式！',
        ic2: '隨時隨地都可以付款！您預留的女傭，經付款後！我們會好快同您聯絡！',
        ih3: '最平的網上續約！',
        ic3: '享受香港最平續約價格！只需要提供相關文件，我們將幫您完成所有工作！續約從未如此簡單！',
        iss: '開始搜尋女傭',
        iss1: '快來網上揾您最心水女傭姐姐幫手啦！！',
        iss2: '把她們加入您的收藏清單，更高效的完成預定女傭！',
        explore: '開始搜尋心水女傭',
        touch: '保持聯絡',
        touch1: '我們將盡快在24小時內回覆您！',
        phone: '電話',
        name: '姓名',
        message: '訊息',
        send: '發送',
        director: '負責人',
        consultant: '顧問',
		assistance: '助理',
        secretary: '文件部秘書',
        des: '本公司良心經營加上擁有十年的僱傭工作經驗，可助分析時下外傭工作背後的真實心聲。高菲團隊也是本著僱主心態，真實的分析助各家庭配對合適外傭，能掌握完約或再續約的技巧。',
        reseve: '高菲傭有限公司最終所有權',
        company1: '屯門貴賓',
        maino: '接待處',
        sideo: '分行',
        addr1: '屯門海榮路22號',
        addr11: '屯門中央廣場地下21號舖',
        company2: '大埔',
        addr2: '新界大埔寶鄉街35號',
        addr21: '寶康大廈地下A1號鋪',
        company3: '天水園',
        addr3: '新界天水園天秀路8號',
        addr31: '天一商城3樓3063號鋪',
        company4: '筲箕灣',
        addr4: '香港筲箕灣南康街17號',
        addr41: '天悅筲箕灣廣場1樓1015號鋪',
        company5: '觀塘',
        addr5: '香港觀塘開源道60號',
        addr51: '駱駝漆大廈3座9字樓A7室',
        company6: '尖沙咀',
        addr6: '九龍尖沙咀漆咸道南87-105號',
        addr61: '百利商業中心1樓39室',
        company7: '長沙灣',
        addr7: '九龍長沙灣青山道654-656號',
        addr71: '浪淘大廈3樓C室',
        company8: '灣仔',
        addr8: '香港灣仔道151-163',
        addr81: '新世紀廣場G22舖',
        search1: '海外菲律賓今天最新女傭 (留意星期一至六早上１０：００)',
        code: '編號',
        name1: '名字',
        age: '年齡',
        birth: '生日',
        zodiac: '生肖',
        marriage: '婚姻',
        kids: '子女',
        st1: '喜愛',
        st2: '喜愛',
        st3: '喜愛',
        religion: '信仰',
        favorite: '收藏',
        favorite11: '收藏',
        status: '狀態',
        about1: '歡迎來到由Jenny創立的GoldenWin Employment Agency Ltd.，我們努力與您合作實現共同目標。',
        about2: '在Golden Win Employment Co., Ltd.，我們致力於為香港公眾服務，特別是忙碌的父母和年幼的孩子及其女傭。我們知道，特別在發展的早期階段培養孩子是一項艱苦的工作，需要很多時間和精力。這就是為什麼我們的目標是為父母及其女傭提供有用的資訊和情感支持，以實現家庭中與女傭的互惠互利。',
        about3: '我們公司的獨特之處在於，我們主要為首次在香港海外的女傭提供服務。我們的使命是為新來香港的女傭提供積極的體驗，讓他們融入香港的新生活方式。我們為通過提供鼓勵、情感和協作支持來彌合僱主和女傭之間關係差距的戰略感到自豪， 由2006 年的經驗的支持下，為您的新生兒、孩子和家庭維護一個養育環境。',
		about7: '我們認為，在沒有雙方仔細考慮的情況下，女傭和僱主關係的轉換不應該是常態，因為轉換的成本是時間、金錢和情感要求。相反，我們的目標是努力與香港僱主和家庭傭工一起工作，打破溝通和績效障礙，以實現互利。我們重視與我們敬愛的香港家庭並肩工作的機會，在孩子成長的每個階段支持他們，以及他們對我們協調下的需求。',
		about8: '我們理解額外的時間、幫手和內心平靜的價值更為重要，我們希望您第一步是選擇能夠為您提供這個服務及倚靠的僱傭公司。',
		about9: '',
        loca: '公司地址',
        about4: '我們將提供最優質的服務，最專業的咨詢，最誠信的品質，最熱情的態度給我們最尊敬的顧客。',
        worktime: '週一至週五 11:00am - 5:30pm',
        worktime1: '週六 10:30am - 2:00pm',
        progress: '手續流程',
        progress1: '香港和菲律賓的海外手續流程',
        price1: '價格項目',
        price2: '由女傭上班入屋起第一天至七個月內，如任何一方提出請辭或辭退，僱主可以更換另一海外菲傭一次 [客戶沒有任何成本]',
        price3: '如工作8個月至24個月合約日期內［日後每次］也享有以HK$6,980更換海外女傭的保障持有VIP貴賓卡',
        price4: '僱主生日月份可分享一位至愛親朋享用VIP貴賓卡',
        price5: '貴賓卡條款使用及細則：',
        price6: '客戶必須一直在僱傭合約生效日期內聘用我們的管理服務',
        price7: '包括客戶的女傭有以下情況：',
		price8: '自攜續約的女傭',
		price9: '不續約或未完成合約的女傭',
		price10: '未能再次續約的女傭',
		price11: '完約合約不續約的女傭',
		price12: '往後每次聘請身在海外的女傭均以 VIP HK$6,980更換女傭',
        p1: '海外（曾在亞洲地區工作）',
        money: '港幣',
        p2: '曾在亞洲地區工作的菲傭之費用包括：',
        p21: '曾在中東地區工作的菲傭之費用包括：',
        p3: '駐港領事館合約費核實費用',
        p4: '香港入境處之入境工作簽證費用',
        p5: '單程來港機票包括：離境稅及機場稅',
        p6: '菲傭到港後兩年的咨詢服務',
        p7: '機場接機',
        p8: '香港身份證申請',
        p9: '到港健康檢查',
        p10: '女傭到港首二晚免費住宿（包括膳食，日常用品）',
        p11: '',
        p111: '包括菲律賓當地中介手續費及當地批核文件證書費',
        pp2: '海外（曾在中東地區工作）',
        pp3: '第一次出國',
        pp4: '未曾出國工作之女傭費用包括：',
        p12: '指定海外女傭',
        p13: '指定海外女傭之費用包括：',
        p14: '店鋪續約',
        p15: '續約費用包括：',
        p151: '網上續約包括：',
        p16: 'OWWA費用',
        p17: '網上續約',
        p18: '客戶自攜在香港的完約女傭',
		p19: '客戶自攜身在海外之女傭',
        p181: '客戶自行有推薦完約之女傭',
        insu: '保險',
        cname: '公司名稱：',
        cname1: '衡安保險顧問公司',
        ty: '兩年',
        df: '下載表格',
        wa: '以下預約海外女傭會談回覆時間',
        form1: '表格下載',
        form2: '香港法定假日（中）',
        form3: '香港法定假日（繁）',
        form4: '勞工處小冊子',
        form41: '中英印對照',
        form5: '申請表格',
        form51: 'ID407E 終⽌合約信',
        form52: 'ID988A  從外國受聘來港家庭傭簽證/延長逗留期限申請表',
        form6: '入境處',
        form7: '勞工處',
        form8: '僱傭終⽌合約計算表',
        form9: '保險保障範圍',
        download: '下載',
        detail: '詳情',
        renew1: '續簽合約',
        renew2: '感謝聘請我們為您的 [外籍家庭僱工]人力資源管理服務',
        renew3: '添加新的家庭成員',
        renew31: '添加',
        renew4: '回到主頁',
        renew5: '2年女傭保險',
        renew6: '如果您對於我們的保險有興趣，請及時聯絡我們的客戶經理。',
        renew7: '請選擇其中一項',
        select: '選擇',
        step: '步驟',
        step1: '填寫資料',
        step2: '付款',
        step3: '發送文件',
        pf1: '女傭姓名',
        pf2: '工資',
        pf3: '預計到港時間',
        pf3a: '盡快',
        pf3b: '之後',
        pf4: '僱主姓名',
        pf41: '僱主香港身份証號碼',
        pf5: '菲律賓當地聯絡人電話',
        pf51: '客戶電話',
        pf6: '辨事處',
        pf7: '你想在哪裡簽合約及文件？',
        pf7a: '辨事處',
        pf7b: '順豐快遞',
        pf8: '郵寄地址',
        pf9: '居住成年人人數（不包括女傭)',
        pf10: '老人數量',
        pf11: '老人健康狀況',
        pf12: '嬰兒數量',
		pf121: '小孩數量',
        pf13: '小孩年齡（請用今年年份計算 ）',
		pf131: '小孩年齡（請用今年年份計算）',
        pf14: '即將出世之嬰兒',
		zz15: '即將出世之嬰兒數量',
        pf15: '出生日期',
        pf16: '房屋類型',
        pf17: '居住面積',
        pf171: '屋企面積',
        pf18: '房間數量',
        pf19: '女傭住宿安排',
        pf20: '主要負責',
        pf21: '照顧初生嬰兒',
        pf22: '照顧幼兒（1-3）',
        pf23: '煮食',
        pf24: '打掃',
        pf25: '照顧老人',
        pf26: '熨燙',
        pf27: '洗衣',
        pf28: '買菜',
        pf29: '管理花園',
        pf30: '洗車',
        pf31: '照顧寵物',
        pf32: '其他',
        pf33: '家務',
        pf34: '照顧小孩（4-6）',
        pf35: '備註 (僅在適用時需要)',
        pf36: '你是否即將有女傭會被接替？',
        pf37: '你家中是否有多於一個女傭一起工作？',
		pf38: '女傭住宿安排 ( 請用英文填寫 )',
        pre: '上一步',
        next: '下一步',
        colon: '：',
        aservice: '附加服務',
        none: '無',
        a2y: '2 年女傭保險',
        insdetail: '保險詳情',
        renewcost: '續簽合同花費',
        total: '共計',
        payamount: '付款金額',
        pay1: '付款',
        favorite1: '收藏清單',
        available: '可預約',
        notavailable: '已聘',
        signin: '登入',
        areaCode: '區號',
        phone1: '電話號碼',
        certify: '输入WhatsApp驗證碼',
        getCertify: '獲取驗證碼',
        password: '密碼',
        password1: '請輸入新的密碼',
        password2: '請再次輸入密碼',
        password3: '密碼重置成功',
        password4: '請登入！',
        noaccount: '沒有賬戶？',
        signup: '註冊',
        adminsignin: '管理員登入',
        domesticsignin: '女傭登入',
        domesticsignup: '女傭註冊',
        su1: '創建新賬戶',
        su2: `使用你的手提電話號碼可以免費註冊賬戶！`,
        fn: '名字',
        ln: '姓氏',
        su3: '我已經閱讀並同意',
        tac: '用戶協議',
        tac1: '隱私與個人資料收集聲明',
        su4: '現在註冊',
        su5: '已有賬戶？',
        filter: '集中搜尋',
        sc: '搜索編號',
        age1: '小於 25',
        age2: '大於 40',
        nomatter: '無所謂',
        m0: '同居',
        m1: '單身',
        m2: '結婚',
        m3: '分居',
        m4: '寡婦',
        m5: '單人',
        son1: '多於 1',
        zo1: '鼠',
        zo2: '牛',
        zo3: '虎',
        zo4: '兔',
        zo5: '龍',
        zo6: '蛇',
        zo7: '馬',
        zo8: '羊',
        zo9: '猴',
        zo10: '雞',
        zo11: '狗',
        zo12: '豬',
        pff1: '女傭檔案',
        share: '分享',
        print: '列印',
        export: 'PDF導出',
        pff2: '海外經驗',
        pff3: '工作經驗',
        pff4: '語言',
        pff41: '按此-影片',
        pff5: '備註',
        pff6: '嚴重疾病歷史',
        pff7: '精神病',
        pff8: '高血壓',
        pff9: '肺部疾病',
        pff10: '吸煙',
        pff101: '皮膚過敏',
        pff11: '紋身',
        pff12: '家庭背景',
        pff13: '父親姓名',
        pff14: '母親姓名',
        pff15: '兄弟姐妹',
        pff16: '家庭住址',
        pff17: '城市/村鎮',
        pff18: '州',
        pff181: '郵編',
        pff19: '身高',
        pff20: '體重',
        account: '賬戶',
        account1: '賬戶',
        contract: '合同',
        contractp: '合同期限',
        un: '用戶名',
        edit: '編輯',
        save: '保存',
        hi: '女傭資料',
        r1: '菲律賓當地聯絡人姓名',
        r2: '與女傭關係',
        r3: '女傭姓名',
        r4: '女傭郵箱',
        r5: '婚姻狀況',
        r51: '致女傭：',
        r52: '请通過 WhatsApp 聯繫 Jeany Rose（+639502100238）了解如何发送其他重要文件来完成申请。',
        r6: '僱主資料',
        flat: '大廈',
        house: '別墅',
        r7: '小孩數量（5-18嵗）（請用今年年份計算）',
        r8: '小孩數量 (0-5嵗)（請用今年年份計算）',
        r9: '預產期嬰兒數量',
        r10: '女傭住宿安排',
        r11: '女傭房間',
        r12: '是的，有一間單獨的房間大約',
        r13: '平方',
        r14: '米',
        r15: '呎',
        r16: '沒有單獨的房間',
        r17: '與',
        r18: '小孩',
        r19: '分享一間房間',
        r191: '單獨分開區域，大約有',
        r20: '其他.請說明',
        r21: '家庭入住成員之資料（入境事務處需要）',
        r22: '英文全名',
        r23: '關係',
        r24: '出生年份',
        r25: '香港身份証號碼',
        r26: '添加新的家庭成員',
        r27: '與現僱主的最後簽證日期 (即批准逗留期限)',
        r28: '現僱主最後工作日期 (只適合於女傭完約轉僱主)',
        r29: '備註',
        r30: '被接替之女傭資料 (僅在適用時需要)',
        r31: '接替女傭姓名',
        r32: '身份証號碼',
        r33: '現僱主最後工作日期',
        r34: '與家中之女傭資料（僅在適用時需要）',
        r35: '最後工作日之簽証曰期',
        r36: '現僱主最後工作日期',
        r37: '女傭之僱主英文全名',
        r38: '現時家中女傭睡房安排',
        a1: '菲傭兩年的咨詢服務',
        a2: '香港健康檢查',
        pr1: '回覆及預約女傭時間',
        pr2: '星期一至五',
        pr3: '星期六',
        pr4: '例子：',
        pr5: '我是陳太（住旺角區）請安排 T1DVO0001 , T1BCD0002 , T1BXN0003 , 22/02 下午2:00 會談 ，電話視頻5611 1111',
        sm1: '女傭編號：',
        sm2: '1) T1DV00111',
        sm3: '2) T1BCD0111',
        sm4: '3) T1ILO0111',
        sm5: '會談時間 ：2:00-3:00 Saturday',
        sm6: '客戶電話：1234 5678',
        sm7: '我們通知菲律賓供應商作,透過你預設日子和時間預約,請短訊發給網站上的WhatsApp 6036 1888 (只適合預約女傭和發送女傭之WhatsApp ) ',
        cancelpay: '取消付款！',
        m: '手提',
        success: '成功',
        paySuccess: '付款成功！',
        cancel: '取消',
        l1: '請通過郵件或者WhatsApp給我們發送文件',
        l2: '僱主香港身份證',
        l3: '收入證明',
        l31: '稅務單',
        l32: '最近三個月的工資支出',
        l33: '最近三個月的銀行對賬單',
        l34: '固定存款港幣$360000，或者',
        l35: '過去六個月儲存金額港幣$360000',
        l4: '地址證明',
        l41: '水費單',
        l42: '電費單',
        l43: '煤氣單 或者',
        l44: '網上行單',
        l5: '關係證明',
        l51: '如果您的住宅不是僱主的名字，請提供住宅擁有人的證明以及與僱主關係的證明',
        l52: '關係證明',
        l53: '結婚證，或者',
        l54: '出生證明',
        l6: '親戚的香港身份證',
        l61: '接替女傭之資料',
        l611: '現女傭之身份証或護照副本',
        l612: '大約離職日期',
        l62: '加聘女傭 （仍在此地址工作之女傭資料）',
        l621: '現女傭之身份証或護照副本',
        l622: '現女傭之僱主（英文全名）',
        l623: '現女傭之最後工作完約日期',
        l624: '現女傭與新聘女傭睡房安排',
        tr1: '請發送給我們清晰的圖片或者掃描以下文件給我們郵箱。',
        tr2: '所有私人信息將保密並只作為僱主核實使用。',
        tr3: '僱主香港身份證',
        tr4: '僱主與女傭合同1-4頁',
        tr5: '',
        tr6: '（請分開上傳四頁合同）',
        tr7: `女傭護照`,
        tr8: `女傭簽證`,
        skip: '稍後再登入',
        f1: '隱私協議',
        f2: '用戶協議',
        resume: '履歷',
        employer_mobile: `僱主電話`,
        employer_name: `僱主姓名`,
        helper_mobile: '女傭香港電話',
        aperson: '登入',
        alogout: '登出',
        afavorite: '收藏',
        constellation: '星座',
        back: '返回',
        afterpay1: '請按（付款/提交）以確認為自己選取的女傭，一經付款我們會為你通知女傭。',
        afterpay2: '按下一頁可以了解所需文件',
        paySuccess1: '「你已成功付款」付款後，你也會收到信用咭公司電郵通知。',
        paySuccess2: '請按下一步，內請按有WhatsApp 圖像 ( 這是文件部秘書，請署名僱主英文全名和女傭編號，她會盡快在辨時間聯絡客戶。',
        paySuccess3: '你亦可預備以下所需文件，直接透過電郵或whatsapp 發送給秘書。',
        signinadd1: '登入選項',
        signinadd2: '客戶登入',
        signinadd3: '女傭登入',
        signinadd4: '管理員登入',
        signinadd5: '回到登入選項',
        signinadd6: '忘記密碼',
        signinadd7: '確認',
        signinadd8: '回到登入页面',
        filterMessage: '請選擇兩項你較重視的項目:',
        fneed: '首選重視',
        sneed: '次選重視',
        need1: 'New Born',
        need2: 'Baby Sitting (Ages 1-3)',
        need3: 'Child Care (Ages 4-12)',
        need4: 'Elderly Care',
        need5: 'Cooking',
        need5: 'Grocery',
        zoall: '選擇所有',
        age1: '小於或等於29歲',
        age2: '大於30歲',
        reset: '重置',
        whatsappmsg: '按此  發送文件 秘書 曾小姐',
        w1: '按此聯絡文件部秘書',
        ol1: '訂單號',
        ol2: '訂單類型',
        ol3: '價格',
        ol4: '創建時間',
        ol5: '付款時間',
        op: '操作',
        pay: '付款',
        paied: '已付款',
		b1: '資料儲存',
		philippines_worker_mobile: '女傭電話',
		process1: `付款時間`,
		process2: `編號`,
		process3: `女傭姓名`,
		process4: `訂單類型`,
		process5: `操作`,
		process6: `批核資訊`,
		cancel: `取消`,
		confirm: `確定`,
		proh1: `女傭資料`,
		proh2: `女傭姓名`,
		proh3: `女傭類別`,
		proh4: `女傭批准工作簽証之生效日期`,
		proh5: `女傭批准工作簽証之到期日`,
		proh6: `女傭離職日期`,
		proh7: `女傭飛機到港日期`,
		proh8: `兩年之合約生效期`,
		proh9: `兩年之續約到期日`,
		proz1: `預計到港日期`,
		proz2: `尚餘時間`,
		proz3: `女傭編號`,
		proe1: `僱主姓名`,
		proe2: `僱主電話`,
		proe3: `中文地址`,
		proe4: `僱主資料`,
		paymentN1:`請選擇確認此女傭的類別`,
		paymentN2:`系統顯示顯示您曾聘用我們服務的最近女傭資料`,
		paymentN3:`女傭姓名`,
		paymentN4:`付款日期`,
		paymentN5:`合約生效日期`,
		pSelectT: `您的類別`,
		pSelectN0: `請選擇您的類別`,
		pSelectN1:`1.加聘這女傭`,
		pSelectN2:`2.新客戶`,
		pSelectN3:`3.高菲客戶更換未來港之女傭`,
		pSelectN4:`4.高菲客戶聘請海外女傭：超過14 個月`,
		pSelectN5:`5.高菲客戶更換由七個月內確認女傭`,
		pSelectN6:`6.高菲客戶更換由八個月至十四個月之女傭`,
		pSelectPay: `請選擇付款方式`,
		paypalT1: `透過PayPal平台使用信用咭付款`,
		paypalT2: `ATM/銀行轉賬`,
		paypalT3: `FPS轉數快`,
		amtH:`ATM/銀行轉賬`,
		amtT:`請將費用轉賬到以下銀行帳戶`,
		amt1:`銀行名稱：`,
		amt2:`中國銀行`,
		amt3:`帳戶號碼：`,
		amt4:`012-831-1-056734-8`,
		amt5:`戶口持有人：`,
		amt6:`GOLDEN WIN EMPLOYMENT AGENCY LIMITED高菲僱傭有限公司`,
		amtf1:`付款後，請上傳收據付款截圖 (請顯示 字眼: 成功轉帳 或 完成轉帳) / 銀行轉帳收據`,
		amtf2:`付款一經確認後，秘書Koty會付款後翌日辦公時間致電給你們對資料`,
		fpsH:`FPS轉數快`,
		fpsT:`請將費用轉賬到以下銀行帳戶`,
		fps1:`電話號碼：`,
		fps2:`51604299`,
		fps3:`請「按」收款銀行選擇`,
		fps4:`中國銀行(香港)有限公司（012）`,
		fps5:`戶口持有人：`,
		fps6:`GOLDEN WIN EMPLOYMENT AGENCY LIMITED高菲僱傭有限公司`,
		pfile:`上傳收據`,
		confirmOrder:`提交`,
		pname: `進程`,
		interview: `加入預約面試`,
		interview1: `安排面試及預約`,
		interviewTitle: `預約面試清單`,
		interviewH: `預約記錄`,
        interview12:`總共選擇`,
        interview13:`安排預約`,
		interview14:`預約女傭`,
		interview15:`姓名`,
		interview16:`稱謂`,
		interview17:`電話`,
		interview18:`郵箱`,
		interview19:`日期`,
		interSt1:`請用英文填寫`,
		interSt2:`請選擇您的稱謂`,
		interSt3:`此電話必須同付款電話一致`,
		interH1:`編號`,
		interH2:`名字`,
		interH3:`電話`,
		interH4:`預約日期`,
		interH5:`預約狀態`,
		interH6:`面試結果`,
		interH7:`完成面試`,
		interH8:`聯絡中`,
		remove:`刪除`,
		email:`電子郵箱`,
		interH9:`更改時間`,
		interviewSubmitContent1:`親愛的客戶`,
		interviewSubmitContent2:`我們已收到你的預約通知`,
		interviewSubmitContent3:`稍後你會收到電郵確認`,
		interviewSubmitContent4:`翌日早上8:00 客戶們開始陸續收到女傭最新狀況`,
		selectAll:`全選`,
		confirmInterview: `確定聘請`,
		paymentRequestT: `温馨提示`,
		kindlyReminder: `温馨提示`,
		close: `關閉`,
		reminderp1:`您的女傭已經成功加入預約面試清單，`,
		reminderp2:`請查閱你的[預約面试清單]安排預約。`,
		newPaymentRp1:`當前頁面信息都爲必填項`,
    }
};
